(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function money(cents) {
    const format = window.Y33_MONEY || "£{{amount}}";
    const n = (Number(cents) || 0) / 100;
    return format
      .replace("{{amount_no_decimals}}", String(Math.round(n)))
      .replace("{{amount}}", n.toFixed(2))
      .replace("{{amount_with_comma_separator}}", n.toFixed(2).replace(".", ","));
  }

  function openDrawer() {
    $(".drawer")?.classList.add("on");
    $(".drawer-bg")?.classList.add("on");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    $(".drawer")?.classList.remove("on");
    $(".drawer-bg")?.classList.remove("on");
    if (!$(".menu-panel")?.classList.contains("open")) document.body.style.overflow = "";
  }

  function setMenu(open) {
    const panel = $(".menu-panel");
    const burger = $(".burger");
    if (!panel) return;
    panel.classList.toggle("open", open);
    burger?.classList.toggle("on", open);
    burger?.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.classList.toggle("menu-lock", open);
    if (open) closeDrawer();
  }

  function renderCount(cart) {
    const n = cart.item_count || 0;
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = n;
      el.style.display = n ? "grid" : "none";
    });
  }

  function renderDrawer(cart) {
    const box = $("[data-cart-lines]");
    const tot = $("[data-cart-total]");
    if (!box) return;
    if (!cart.items || !cart.items.length) {
      box.innerHTML = '<p class="empty">Your bag is empty. Edition pieces go fast.</p>';
      if (tot) tot.textContent = money(0);
      return;
    }
    box.innerHTML = cart.items
      .map(
        (i) => `
      <div class="line" data-key="${i.key}">
        <img src="${i.image ? i.image.replace(/(\.[^.]*)$/, "_120x$1") : ""}" alt="">
        <div>
          <h4>${i.product_title}</h4>
          <p>${i.variant_title && i.variant_title !== "Default Title" ? i.variant_title + " · " : ""}${money(i.final_line_price)}</p>
          <div class="line-qty">
            <button type="button" data-qty="${i.quantity - 1}" data-key="${i.key}" aria-label="Less">−</button>
            <span>${i.quantity}</span>
            <button type="button" data-qty="${i.quantity + 1}" data-key="${i.key}" aria-label="More">+</button>
          </div>
          <button data-qty="0" data-key="${i.key}" style="margin-top:6px;font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:#c4161c;cursor:pointer">Remove</button>
        </div>
        <div>${money(i.final_line_price)}</div>
      </div>`
      )
      .join("");
    if (tot) tot.textContent = money(cart.total_price);
  }

  async function getCart() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return null;
      const cart = await res.json();
      renderCount(cart);
      renderDrawer(cart);
      return cart;
    } catch (e) {
      return null;
    }
  }
  async function changeItem(key, qty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    return getCart();
  }
  async function addItem(id, qty) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id, quantity: qty || 1 }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.description || "Could not add that piece.");
      return;
    }
    await getCart();
    openDrawer();
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-cart]")) {
      e.preventDefault();
      setMenu(false);
      openDrawer();
    }
    if (e.target.closest("[data-close-cart]")) closeDrawer();
    const qtyBtn = e.target.closest("[data-key][data-qty]");
    if (qtyBtn) changeItem(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.qty, 10));
    if (e.target.closest(".menu-panel a")) setMenu(false);
  });

  $$("[data-ajax-cart]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const id = form.querySelector('[name="id"]')?.value;
      if (id) addItem(id, 1);
    });
  });

  $$("[data-size]").forEach((b) => {
    b.addEventListener("click", () => {
      b.closest("[data-sizes]").querySelectorAll("[data-size]").forEach((x) => x.classList.remove("on"));
      b.classList.add("on");
      const input = $("[data-variant-id]");
      if (input && b.dataset.variant) input.value = b.dataset.variant;
      const price = $("[data-variant-price]");
      if (price && b.dataset.price) price.innerHTML = b.dataset.price;
      const add = $("[data-add]");
      if (add) {
        add.disabled = b.classList.contains("sold");
        add.textContent = b.classList.contains("sold") ? "Sold out" : "Add to bag";
      }
    });
  });

  $$("[data-filter]").forEach((b) => {
    b.addEventListener("click", () => {
      const type = b.dataset.filter;
      $$("[data-filter]").forEach((x) => x.classList.remove("on"));
      b.classList.add("on");
      $$("[data-product-card]").forEach((card) => {
        card.style.display = type === "all" || card.dataset.type === type ? "" : "none";
      });
      const n = $("[data-shop-count]");
      if (n) {
        const shown = $$("[data-product-card]").filter((c) => c.style.display !== "none").length;
        n.textContent = shown + " pieces";
      }
    });
  });

  $("[data-sort]")?.addEventListener("change", (e) => {
    const val = e.target.value;
    const url = new URL(location.href);
    if (val) url.searchParams.set("sort_by", val);
    else url.searchParams.delete("sort_by");
    location.href = url.toString();
  });

  $(".burger")?.addEventListener("click", () => {
    setMenu(!$(".menu-panel")?.classList.contains("open"));
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setMenu(false);
      closeDrawer();
    }
  });

  function setAcc(item, open) {
    item.classList.toggle("open", open);
    const btn = item.querySelector("[data-acc]");
    if (!btn) return;
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    const mark = btn.querySelector("span");
    if (mark) mark.textContent = open ? "−" : "+";
  }
  $$("[data-acc]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".acc-item");
      const open = !item.classList.contains("open");
      const group = btn.closest("[data-acc-single]");
      if (group) group.querySelectorAll(".acc-item").forEach((el) => setAcc(el, false));
      setAcc(item, open);
    });
  });

  const caption = $("[data-caption]");
  const slides = $$("[data-slide]");
  $$("[data-thumb]").forEach((t) => {
    t.addEventListener("click", () => {
      const id = t.dataset.target;
      if (!id || !slides.length) return;
      slides.forEach((s) => {
        const on = s.dataset.slide === id;
        s.hidden = !on;
        s.classList.toggle("on", on);
        if (!on) s.querySelectorAll("video").forEach((v) => v.pause());
      });
      if (caption) caption.textContent = t.dataset.caption || "";
      $$("[data-thumb]").forEach((x) => x.classList.remove("on"));
      t.classList.add("on");
    });
  });

  getCart();
})();
